import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as S from './TabsGroup.styles';

const useWindowLocation = () => {
  const [path, setPath] = useState(window.location.pathname);
  const [hash, setHash] = useState(window.location.hash);
  const listenToPopstate = () => {
    setPath(window.location.pathname);
    setHash(window.location.hash);
  };
  useEffect(() => {
    window.addEventListener('popstate', listenToPopstate);
    return () => {
      window.removeEventListener('popstate', listenToPopstate);
    };
  }, []);
  return [path, hash];
};

const TabsGroup = ({ tabs, onClick }) => {
  const handleClick = (event, location) => {
    const index = event.currentTarget.getAttribute('data-index');
    const tab = tabs[index];
    tab.hasSubLevel
      ? !location.includes(tab.path) && onClick(tab.path)
      : location !== tab.path && onClick(tab.path);
  };

  const shouldShowMe = ({ show }) => (show === undefined ? true : show);

  const [locationPathName, locationHash] = useWindowLocation();

  return (
    <S.TabGroup>
      {tabs.map(
        (tab, index) =>
          shouldShowMe(tab) && (
            <S.TabGroupTab
              key={index}
              data-index={index}
              active={
                (tab.hasSubLevel
                  ? locationPathName.includes(tab.path)
                  : tab.path === locationPathName) || tab.path === locationHash
              }
              onClick={(e) => handleClick(e, locationPathName)}
            >
              <S.TabGroupTabTitle>{tab.label}</S.TabGroupTabTitle>
            </S.TabGroupTab>
          )
      )}
    </S.TabGroup>
  );
};

TabsGroup.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      show: PropTypes.bool,
      hasSubLevel: PropTypes.bool,
    })
  ).isRequired,
  onClick: PropTypes.func,
};

export default TabsGroup;
